import React, { useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { Table } from "antd";
import useGetAttributes from "../../hooks/useGetAttributes";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import useCreateAttribute from "../../hooks/useCreateAttribute";
import UseUpdate from "../../hooks/UseUpdate";
import useDeleteItem from "../../hooks/useDeleteItem";
import useFetchItems from "../../hooks/useFetchItems";
import { evacuationPlanningColumns } from "./AllColumnsData";
import useModalHandlers from "../../hooks/useModalHandler";
import useChangeHandler from "../../hooks/useChangeHandler";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

const MODULE_NAMES = ["Evacuation Planning", "Emergency Shelter Locations", "Go Bag Name",
"Vehicle Information",
];
export default function EvacuationPlanning() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState("Evacuation Planning");
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();
  const {
    errorState,
    fetchData,
    fieldsData,
    disasterAttributeData,
    loadingState,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useFetchItems(MODULE_NAMES, setLoading);
  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { attributes, disasterAttribute, error } = useGetAttributes(MODULE_NAMES, setLoading);
  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(fetchData, formatModuleKey, setTableData, setLoading);

  const { showModal, updateModal, viewModal, handelCloseModal } = useModalHandlers(
    attributes,
    setModalTitle,
    setModuleName,
    setIsModalVisible,
    setFormData,
    setAttributesData
  );
  const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const tableDataObj = {
    "Emergency Shelter Locations": tableData.emergencyShelterLocationsData,
    "Vehicle Information":tableData.vehicleInformationData,
    "Go Bag Name": tableData.goBagNameData,
  };

  console.log("tableData", tableData);

  const allColumnsData = evacuationPlanningColumns(viewModal, updateModal, deleteRecord);

  const AddAssets = () => {
    history.push("/asset_allocation");
  };
  const collapseableTables = [
    { title: "Emergency Shelter Locations", key: 1 },
    { title: "Vehicle Information", key: 2 },
    { title: "Go Bag Name", key: 3 },
  ];
  return (
    <div style={{ position: "relative" }}>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Evacuation Planning</h2>
        <ToolTipCreator name={"Disaster_Evacuation_Planning"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      {disasterAttribute && (
        <>
          <DisabilityFormCreator
            data={disasterAttribute}
            values={disasterAttributeData}
            setSubmitBody={setFormData}
          />
          <div className="handle-submit-button-container">
            <button
              className="submit-button"
              onClick={async () => {
                if (toUpdate) {
                  await updateRecord();
                } else {
                  await createAttributes();
                }
              }}
            >
              {toUpdate ? "Update" : "Submit"}
            </button>
          </div>
        </>
      )}
      {collapseableTables.map((table, idx) => (
        <CollapseableTable
        title={table.title}
        key={table.key}
        onClick={() => showModal(table.title)}
      >
        <Table columns={allColumnsData[table.title]} dataSource={tableDataObj[table.title]} />
      </CollapseableTable>
       // replace with Table component for real implementation  // to add assets we need to pass the module name as props to the component  // and fetch the data from the API for the given module.  // For now, we are using a dummy data.
      ))}
      <div>
        <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loadingState}
        />
      </div>
      {/* <DisabilityFormCreator /> */}
      <NewLoader isLoading={loading} />
    </div>
  );
}
